<z-modal open="true" [color]="'bg-exp'">
    <ng-container header>
        <div class="flex flex-row gap-2 items-center">
            <i
                class="fal fa-user text-white bg-exp shadow-xl rounded-full h-10 w-10 text-xl text-center leading-10"></i>
            <h4 class="text-2xl font-bold text-zen">
                {{ 'txtChangeEmail' | translate:language:ModuleNames.Common }}
            </h4>
        </div>
    </ng-container>

    <ng-container body>
        <div class="flex flex-row items-start gap-5">
            <form autocomplete="off" [formGroup]="form" class="flex flex-col w-full">
                <div class="flex flex-row gap-1 items-center w-full ">
                    <z-input type="email" class="w-full" [disabled]="true" [required]="true" [language]="language"
                        [label]="'txt_CurrentEm_318' | translate: language:ModuleNames.Common"
                        formControlName="currentEmail"></z-input>

                    <z-input type="email" class="w-full" [required]="true" [language]="language"
                        [label]="'txt_NewEmail_444' | translate: language:ModuleNames.Common"
                        formControlName="newEmail"></z-input>

                </div>
                <h5 *ngIf="form.get('newEmail')?.errors as errors">
                    <validation-required *ngIf="errors.required && form.get('newEmail').dirty"
                        [language]="language"></validation-required>
                    <div *ngIf="errors.email" class="text-red-600 text-xxs flex flex-row items-center gap-1 leading-5">
                        <i class="fa-solid fa-exclamation-circle"></i>
                        <span>
                            {{ 'txtEmailRequired' | translate:language:ModuleNames.Common }} :

                        </span>

                    </div>
                </h5>

            </form>
            <div class="flex flex-row items-center justify-end gap-2 -mt-2">

            </div>
        </div>




    </ng-container>

    <ng-container footer>
        <a (click)="closeModal()"
            class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{
            "btn_cancel" |
            translate: language:ModuleNames.Common }}</a>
        <a (click)="changeEmail()"
            class="btn exp text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">
            {{ "txt_SaveChang_623" | translate: language:ModuleNames.Common }}
        </a>
    </ng-container>
</z-modal>